"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DTOFactory = exports.GalBaseDTO = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const decorators = __importStar(require("../decorators"));
const analytics_1 = require("./analytics");
const gal_events_1 = require("./gal-events");
class GalBaseDTO {
    constructor() {
        this.type = gal_events_1.GalEvents[this.constructor.name];
    }
}
__decorate([
    decorators.ConversionType(decorators.CONVERSION_TYPE.snake_case_sans_dto),
    (0, class_validator_1.IsDefined)(),
    decorators.Example('GalEvents'),
    decorators.Describe('Event type required for validation'),
    decorators.Warning('Must match DTO type'),
    __metadata("design:type", String)
], GalBaseDTO.prototype, "type", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Function)
], GalBaseDTO, "allowedGroups", void 0);
exports.GalBaseDTO = GalBaseDTO;
const DTOFactory = (allowedGroups = [analytics_1.GalReportingGroups.unrestricted]) => {
    return class GalDTO extends GalBaseDTO {
        constructor() {
            super(...arguments);
            this.type = gal_events_1.GalEvents[this.constructor.name];
        }
        static allowedGroups() {
            return Object.freeze(allowedGroups);
        }
    };
};
exports.DTOFactory = DTOFactory;
